module.exports = __webpack_public_path__ + "static/media/mcqMomentDiagram2.12dcc7a1.svg";